import type { RouteObject } from 'react-router-dom';
import { AuthLayout } from '@/layouts/AuthLayout';
import { GuestGuard } from '@/app/router/guards/GuestGuard';
import { LoginPage } from '@/features/auth/pages/LoginPage';
import { SignupPage } from '@/features/auth/pages/SignupPage';
import { OtpVerifyPage } from '@/features/auth/pages/OtpVerifyPage';
import { UserDetailPage } from '@/features/auth/pages/UserDetailPage';
import { CreatePasswordPage } from '@/features/auth/pages/CreatePasswordPage';
import { ForgotPasswordPage } from '@/features/auth/pages/ForgotPasswordPage';
import { ResetPasswordPage } from '@/features/auth/pages/ResetPasswordPage';
import { routes } from '@/shared/config/routes';

export const guestAuthRoutes: RouteObject[] = [
  {
    element: <GuestGuard />,
    children: [
      {
        element: <AuthLayout />,
        children: [
          { path: routes.login, element: <LoginPage /> },
          { path: routes.signin, element: <LoginPage /> },
          { path: routes.signup, element: <SignupPage /> },
          { path: routes.otpVerify, element: <OtpVerifyPage /> },
          { path: routes.forgotPassword, element: <ForgotPasswordPage /> },
          { path: routes.resetPassword, element: <ResetPasswordPage /> },
          { path: routes.userDetail, element: <UserDetailPage /> },
          { path: routes.createPassword, element: <CreatePasswordPage /> },
        ],
      },
    ],
  },
];
